import { MAX_PROGRESS_ALLOWED_FOR_BYTE_TRANSFER } from '../../constants';

/*
File uploads are composed of two parts. There is the transfer of bytes to the server, and then a final API call that sets the status of the item
uploaded so that we ensure it will show up in the recent uploads list.

The file transfer portion will advance the progress bar up to the 99% mark. Only once the final API call to set the status is made will the
isUploadComplete variable be set to true, which will result in the progress bar advancing to 100%.
*/

const getProgressPercent = (progressSoFar: number, progressTotal: number, isUploadComplete: boolean): number => {
  if (isUploadComplete) {
    return 100;
  }
  // protect ourselves from division by 0
  if (progressTotal === 0) {
    return 0;
  }

  // determine progress for sending bytes to server
  const progressAsFraction = progressSoFar / progressTotal;
  let progressAsInteger = Math.floor(progressAsFraction * MAX_PROGRESS_ALLOWED_FOR_BYTE_TRANSFER);
  // safety check in case progressSoFar was higher than progressTotal
  if (progressAsInteger > MAX_PROGRESS_ALLOWED_FOR_BYTE_TRANSFER) {
    progressAsInteger = MAX_PROGRESS_ALLOWED_FOR_BYTE_TRANSFER;
  }
  // always show at least 1% so the user knows we are doing something
  return Math.max(1, progressAsInteger);
};

export default getProgressPercent;
